import { withTheme, withStyles } from "@mui/styles";
import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { AbilityContext } from "src/config/ability-context";
import { Styles } from "src/styles/material-styles";
import { bindActionCreators } from "redux";
import { Container, Grid, Typography, Paper } from "@mui/material";
import { browserHistory } from "src/helpers/history";
import Header from "src/components/header-external";
import CustomizedSnackbars from "src/components/material-snackbars";
import Footer from "src/components/footer-external";
import { Search } from "@mui/icons-material";
import Api from "src/services/api";
import * as componentActions from '../../redux/actions/articles';
import PropTypes from 'prop-types';
import ArticleCard from "./components/ArticleCard";
import HeaderArticleCards from "./components/HeaderArticleCards";
import LogoMarca from 'src/images/new-logo2-cmtech.png'
import { PapiroConsole } from "src/utils/papiroConsole";
import Modal from "src/components/modal-external/modal-principal";
import CalledServicesSettingsExternalFormList from "../client-portal-external/components/called-services-settings-external-form-list";
import SkeletonCommonExternalDynamicArticles from "src/components/client-portal/skeleton-common-external-dynamic-articles";
import CommonExternalDynamicArticles from "src/components/client-portal/common-external-dynamic-articles";
import CommonSearchExternal from "src/components/client-portal/common-search-external";
import CommonBackButtonExternal from "src/components/client-portal/common-back-button-external";
import CommonPaginateSkeleton from "src/components/client-portal/common-paginate-skeleton";
import CommonTotalPagesCount from "src/components/client-portal/common-total-pages-count";
import CustomIcon from "src/components/custom-icon";

class ArticleListExternal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            articles: [],
            clientportal: {},
            loading: false,
            loadingArticle: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            createCalledDialogOpen: false,
            calledServiceSettingsList: [],
            appName: Api != null ? Api.getAppName() : "CMTECH - Mexx 2DO",
            totalPages: 0,
            pageStart: 0,
            pageEnd: 0,
            count: 0,
            searchvalue: this.props.articles.articlesearch,
            searchtype: this.props.articles.searchtype,
            logoimagesrc: '',
            mainimagesrc: ''
        }

        this.closeNotification = this.closeNotification.bind(this)
        this.openCreateCalledDialog = this.openCreateCalledDialog.bind(this)
        this.closeCreateCalledDialog = this.closeCreateCalledDialog.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    async componentDidMount() {

        document.title = this.state.appName;

        this.setState({ loading: true })

        await this.getHirerId()
        await this.getClientPortal()
        await this.getArticles(1, true)

        this.setState({ loading: false })
    }

    closeNotification = () => {
        this.setState({ openNotification: false })
    }

    openCreateCalledDialog = (calledServiceSettingsList) => {
        this.setState({
            createCalledDialogOpen: true,
            calledServiceSettingsList: calledServiceSettingsList
        })
    }

    closeCreateCalledDialog = () => {
        this.setState({ createCalledDialogOpen: false })
    }

    setPagination(count, page) {

        let totalPage = Math.ceil(count / 10);
        this.setState({ totalPages: totalPage })
        if (count > 0) {
            if (page == 1) {
                if (count < 10) {
                    this.setState({ pageStart: 1, pageEnd: count })
                } else {
                    this.setState({ pageStart: 1, pageEnd: 10 })
                }
            } else {
                let pageStart = ((page - 1) * 10) + 1
                if (count >= page * 10) {
                    this.setState({ pageStart: pageStart, pageEnd: page * 10 })
                } else {
                    this.setState({ pageStart: pageStart, pageEnd: count })
                }
            }
        } else {
            this.setState({ totalPages: 0, page: 1, count: 0 })
        }
    }

    getHirerId = async () => {
        const intl = this.props.intl

        await Api.get(`/configs/cancreateclientusersexternal`)
            .then(result => {
                if (result.data.success) {
                    if (result.data.data != null) {
                        if (result.data.data.hirerid != null && result.data.data.hirerid > 0)
                            this.setState({ hirerid: result.data.data.hirerid })
                        else {
                            var l = this.props.match.params.lang;
                            document.location.href = `/${l}/unavailable`
                        }
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err)
            })
    }

    async getClientPortal() {
        const intl = this.props.intl

        await Api.get(`/clientportal/external/hirer/${this.state.hirerid}`)
            .then(result => {
                if (result.data && result.data.success) {
                    this.setState({
                        clientportal: result.data.data
                    })
                    if (result.data.data.logoimage) {
                        this.getImageFile(result.data.data.logoimage, 'logoimagesrc')
                    } else {
                        const image = Api.getLoginImage()
                        if (image) {
                            this.getImageFile(image, 'logoimagesrc')
                        } else {
                            this.setState({ logoimagesrc: LogoMarca })
                        }
                    }
                    if (result.data.data.mainimage) {
                        this.getImageFile(result.data.data.mainimage, 'mainimagesrc')
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result.data)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
            })
    }

    async getArticles(page = 1, mount = false) {

        const { intl } = this.props

        if (!mount) {
            this.setState({ loadingArticle: true })
        }

        let url = ``

        PapiroConsole.log("this.state.searchvalue")
        PapiroConsole.log(this.state.searchvalue)
        if (this.state.searchvalue) {
            PapiroConsole.log("entrei aqui 1")
            if (this.state.searchtype == 'text' && this.state.searchvalue.length > 0) {
                url = `articles/paginate/external?page=${page}&hirerid=${this.state.hirerid}&search=${this.state.searchvalue}`
            } else if (this.state.searchtype == 'articlesectionid' && this.state.searchvalue > 0) {
                PapiroConsole.log("entrei aqui 2")
                url = `articles/paginatebyarticlesection/external/${this.state.searchvalue}?page=${page}&hirerid=${this.state.hirerid}`
            } else {
                PapiroConsole.log("entrei aqui 3")
                url = `articles/paginate/external?page=${page}&hirerid=${this.state.hirerid}&search=${this.state.searchvalue}`
            }
        } else {
            PapiroConsole.log("entrei aqui 4")
            url = `articles/paginate/external?page=${page}&hirerid=${this.state.hirerid}`
        }

        await Api.get(url)
            .then(result => {
                if (result.data && result.data.success) {

                    let count = result.data.count
                    this.setState({ count: count })
                    this.setPagination(count, page)

                    this.setState({
                        articles: result.data.data
                    })
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        loadingArticle: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    loadingArticle: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
            })

        if (!mount) {
            this.setState({ loadingArticle: false })
        }
    }

    getImageFile = async (image, stateKey) => {
        let xhttpImage = new XMLHttpRequest()
        xhttpImage.open("GET", `${image.anonymoustoken}`, false)
        xhttpImage.setRequestHeader('Access-Control-Allow-Origin', '*')
        try {
            xhttpImage.send()
            let ImageData = JSON.parse(xhttpImage.responseText)
            if (ImageData && ImageData.data && ImageData.data.length > 0) {
                this.setState({ [stateKey]: ImageData.data })
            }
        }
        catch (e) {
            PapiroConsole.log("e")
            PapiroConsole.log(e)
        }
    }

    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value

        this.setState({
            [name]: value
        })
    }

    searchArticle = () => {
        this.props.addCurrentSearch(this.state.searchvalue)
        this.getArticles(1)
    }

    onChangePaginate = (e, page) => {
        this.setState({ page: page });
        this.getArticles(page);
    }

    handleBack = () => {
        if (this.props.history.length > 1) {
            browserHistory.goBack();
        } else {
            this.props.history.push(`/${this.props.match.params.lang}/client-portal-external`);
        }
    };

    render() {
        const { intl, classes } = this.props
        const { clientportal, articles, logoimagesrc, mainimagesrc, loading, loadingArticle } = this.state;

        const theme = this.props.theme;
        const primaryColor = theme.palette.primary.main;
        const accentColor = clientportal && clientportal.defaultcolor ? clientportal.defaultcolor : primaryColor

        return (
            <div>
                <main className={classes.contentExternal} >
                    <Container style={{ maxWidth: '100vw', width: '100vw', margin: 0, padding: 0 }}>
                        <Grid container width="100%" direction="column" justifyContent="space-between" minHeight="100vh">
                            <Grid item container>
                                <Header
                                    intl={intl}
                                    clientportal={clientportal}
                                    calledservicesettings={clientportal.calledservicesettingsclientportals}
                                    language={this.props.match.params.lang}
                                    openCreateCalledDialog={this.openCreateCalledDialog}
                                    logoimagesrc={logoimagesrc}
                                    loading={this.state.loading}
                                />

                                <CommonSearchExternal
                                    state={this.state}
                                    clientportal={clientportal}
                                    loading={loading}
                                    nameTextField={"searchvalue"}
                                    handleChange={this.handleChange}
                                    searchArticle={this.searchArticle}
                                    mainImageSrc={mainimagesrc}
                                />

                                <Grid item sm={12} container marginX="20vw" maxWidth={'60vw'} mt={4}>
                                    <CommonBackButtonExternal
                                        clientportal={clientportal}
                                        loading={loading}
                                        handleBack={this.handleBack}
                                    />
                                </Grid>

                                <CommonPaginateSkeleton
                                    loading={loading || loadingArticle}
                                    marginInline='20vw'
                                    simple
                                />

                                {(!loading && !loadingArticle) && (
                                    <React.Fragment>
                                        <Grid item container sm={12} marginX="20vw" spacing={4} mt={1} style={{ maxWidth: '60vw', paddingLeft: "0 !important" }} >
                                            {articles && articles.length > 0 ? (
                                                <Grid item xs={12} sx={{ paddingLeft: "0 !important" }}>
                                                    <Paper
                                                        elevation={0}
                                                        sx={{
                                                            backgroundColor: '#fff',
                                                            borderRadius: '16px',
                                                            overflow: 'hidden',
                                                            border: '1px solid #f0f0f0',
                                                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
                                                        }}
                                                    >
                                                        <HeaderArticleCards
                                                            clientportal={clientportal}
                                                        />

                                                        {articles.map((article, index) => (
                                                            <ArticleCard
                                                                key={article.id}
                                                                article={article}
                                                                clientportal={clientportal}
                                                                isLast={index === articles.length - 1}
                                                            />
                                                        ))}
                                                    </Paper>
                                                </Grid>
                                            ) : (
                                                <Grid item xs={12} sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '40px',
                                                    borderRadius: '8px',
                                                    textAlign: 'center'
                                                }}>
                                                    <CustomIcon icon={Search} color={accentColor} iconSx={{ fontSize: 60, marginBottom: 2 }} />

                                                    <Typography variant="h5" sx={{ color: theme.palette.text.primary, marginBottom: 1 }}>
                                                        {intl.formatMessage({ id: "content.not.found" })}
                                                    </Typography>
                                                    <Typography variant="body1" sx={{ color: theme.palette.text.secondary }}>
                                                        {intl.formatMessage({ id: "try.different.search" })}
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </Grid>

                                        {articles && articles.length > 0 &&
                                            <Grid item container marginX="20vw" mt={5} style={{ marginBottom: 12 }}>
                                                <CommonTotalPagesCount state={this.state} onChangePaginate={this.onChangePaginate} clientportal={clientportal} />
                                            </Grid>
                                        }
                                    </React.Fragment>
                                )}

                                <Grid container marginX="20vw" maxWidth={'60vw'} spacing={5} mt={1}>
                                    <SkeletonCommonExternalDynamicArticles loading={this.state.loading} />

                                    {!this.state.loading &&
                                        <CommonExternalDynamicArticles
                                            clientportal={clientportal}
                                            hirerid={this.state.hirerid}
                                            setNotification={this.setNotification}
                                        />
                                    }
                                </Grid>
                            </Grid>
                            <Footer
                                intl={intl}
                                clientportal={clientportal}
                                loading={this.state.loading}
                                setLoading={loading => this.setState({ loading: loading })}
                            />
                        </Grid>

                        <Modal
                            intl={intl}
                            title={<strong style={{ color: this.state.clientportal.defaulttextcolor }}>{this.state.clientportal.createcalledpagetitle || intl.formatMessage({ id: "choose.form" })}</strong>}
                            open={this.state.createCalledDialogOpen}
                            onClose={this.closeCreateCalledDialog}
                            contentPadding={false}
                            maxWidth="md"
                            children={
                                <CalledServicesSettingsExternalFormList
                                    calledServiceSettingsList={this.state.calledServiceSettingsList}
                                    clientportal={clientportal}
                                />
                            }
                        />

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
            </div>
        )
    }
}

ArticleListExternal.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
    classes: PropTypes.object.isRequired,
    articles: state.articles,
})

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);
export default withTheme(injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ArticleListExternal))));
ArticleListExternal.contextType = AbilityContext;